import { Button, Col, Row } from "antd";
import Loading from "components/Loading";
import { get } from "lodash";
import React, { useMemo } from "react";
import { useClassUsers } from "store/userClasses/selectors";
import styled from "styled-components";
import { DebateLftIcon } from "utils/assets/images";
import { bingoImageUrl } from "utils/config/reference";
import "./bingo.css";
import { getMandatoryCellMessage, isMandtoryCells } from "./helper";
import PrintLoteria from "./PrintBingo/PrintLoteria";
import GridCustomView from "./teacher/gridCustomView.jsx";
import SentryWrap from 'components/Sentry';

const LoaderWrapper = styled.div`
  // position:absolute;
  z-index: 100;
`;

const BingoGridSection = ({
  handleClickHideSec = () => null,
  grid,
  selectedType,
  backHandler = () => null,
  setGrid,
  bingoSize,
  currentUser,
  actionForCreate = {},
  showSnack
}) => {
  const classUsers = useClassUsers();
  const classStudentUsers = classUsers?.filter(
    (obj) => obj?.role === "student"
  );


  const validateGrid = useMemo(() => {
    if (!grid) return false;

    const flatGrid = grid.flat();
    const mandatoryCells = Number(isMandtoryCells(bingoSize));

    const currentValidCells = (() => {
      switch (selectedType) {
        case "VocabImage":
          return flatGrid.filter((cell) => cell?.value && cell?.imageUrl)
            .length;
        case "Image":
          return flatGrid.filter((cell) => cell?.value && cell?.imageUrl)
            .length;
        case "OnlyImage":
          return flatGrid.filter((cell) => cell?.imageUrl).length;
        default:
          return flatGrid.filter((cell) => cell?.value).length;
      }
    })();

    return currentValidCells >= mandatoryCells;
  }, [grid, selectedType]);

  return (
    <SentryWrap>
      <div className="ideaMdlUpr">
      <Row>
        <Col xs={24}>
          <div className="flex bingoMdlTop justify-between">
            <div className="debateMdlTop">
              <img className="bingo-logo" src={bingoImageUrl} alt="Logo" />
            </div>
            <div>
              <div className="flex justify-end">
                {get(currentUser, "role") === "teacher" && (
                  <PrintLoteria
                    bingoSize={bingoSize}
                    selectedType={selectedType}
                    grid={grid}
                    classUsers={classStudentUsers}
                    isGridValid={validateGrid}
                    showSnack={showSnack}
                  />
                )}
              </div>

              <div className="text-end w-full text-red mb-10px">
                {getMandatoryCellMessage(bingoSize || 0)}
              </div>
            </div>
          </div>
        </Col>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {!actionForCreate?.loader && (
          <div
            onClick={() => {
              if (actionForCreate?.loader) {
                return;
              }
              backHandler("gridSection")
            }}
            style={{ top: "4px" }}
            className="cursor-pointer mt-2 bingoBackBtn"
          >
            <img src={DebateLftIcon} alt="Back" />
          </div>
          )}

          <GridCustomView
            grid={grid}
            selectedType={selectedType}
            setGrid={setGrid}
            bingoSize={bingoSize}
          />
        </div>
        <div className="flex items-center justify-end w-full mt-10px">
          <div className="bingoCountTypeSec">
            <div className="custoMshareBtn flex items-center gap-10px">
              <Button
                style={{ display: "flex", alignItems: "center" }}
                type="primary"
                className="shareBtnSec"
                onClick={() => {
                  if (
                    actionForCreate?.loader &&
                    actionForCreate?.type === "save"
                  ) {
                    return;
                  }
                  handleClickHideSec("save");
                }}
                disabled={!validateGrid || actionForCreate?.loader}
              >
                {actionForCreate?.loader && actionForCreate?.type === "save" ? (
                  <LoaderWrapper>
                    <Loading size={18} white />
                  </LoaderWrapper>
                ) : null}{" "}
                Save
              </Button>

              {get(currentUser, "role", "") !== "owe_admin" && (
                <Button
                  style={{ display: "flex", alignItems: "center" }}
                  type="primary"
                  className="shareBtnSec"
                  onClick={() => {
                    if (
                      actionForCreate?.loader &&
                      actionForCreate?.type === "save_and_start"
                    ) {
                      return;
                    }
                    handleClickHideSec("save_and_start");
                  }}
                  disabled={!validateGrid || actionForCreate?.loader}
                >
                  {actionForCreate?.loader &&
                  actionForCreate?.type === "save_and_start" ? (
                    <LoaderWrapper>
                      <Loading size={18} white />
                    </LoaderWrapper>
                  ) : null}
                  Save and start
                </Button>
              )}
            </div>
          </div>
        </div>
      </Row>
      </div>
    </SentryWrap>
  );
};
export default BingoGridSection;
